import React, { Fragment, useEffect, useState } from 'react';
import SwitchSelect from '../../Components/Components/SwitchSelect';
import Toggle from '../../Components/Components/Toggle';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getUserAutoPlay, getUserShowHint, getUserShowIgnoredRooms, handleSetTheme, setUserLoginStatistics, toggleAutoPlay, toggleShowHint, toggleShowIgnoredRooms, updateAutoMergeRooms, updateDisabledEmoticons, updateDisabledReceivingGifts, updateDisabledShowGifts } from '../../../../../actions/member';
import { changeGameSetting, changeNotificationSettings, setDefaultSettings, toggleAllNotificationSettings } from '../../../../../actions/userSettings';
import { map } from 'lodash';
import { MENU_NAVIGATION, SCREEN_MODE, SCREEN_MODE_OPTIONS, USER_SYSTEM_SETTINGS } from '../../../../../constants/constants';
import IconPopover from '../../Components/Components/IconPopover';
import { Button, Media, ModalFooter } from 'reactstrap';
import ReactGA from "react-ga";
import lvFlag from '../../../../../images/redesign/flags/lv.svg';
import ruFlag from '../../../../../images/redesign/flags/ru.svg';
import enFlag from '../../../../../images/redesign/flags/en.svg';

import DarkThemeModeIcon from '../../../../../images/redesign/mobile/icons/dark-theme-mode-icon.svg';
import NormalThemeModeIcon from '../../../../../images/redesign/mobile/icons/normal-theme-mode-icon.svg';
import LightThemeModeIcon from '../../../../../images/redesign/mobile/icons/light-theme-mode-icon.svg';
import DarkSelectedThemeIcon from '../../../../../images/redesign/mobile/icons/dark-theme-selected-mode-icon.svg';
import NormalSelectedThemeModeIcon from '../../../../../images/redesign/mobile/icons/normal-theme-selected-mode-icon.svg';
import LightSelectedThemeModeIcon from '../../../../../images/redesign/mobile/icons/light-theme-selected-mode-icon.svg';
import SoundButton from '../../Components/Layout/SoundButton';

const UserSettingsNew = ({
  changeTab,
  showUserSettingsModal,
  fetchAutoPlay,
  fetchShowHint,
  fetchShowIgnoredRooms,
  setDefault,
  notificationSettings,
  uid,
  newDesign,
  gameSettings,

  disabledAutoPlay,
  autoMergeRooms,
  showHint,
  showIgnoredRooms,

  vipUntil,
  offset,

    disabledEmoticons,
    disabledReceivingGifts,
    disabledShowGifts,
    setUserLoginStatisticsDispatch,
    screenMode,
    handleSetThemeDispatch,
    changeSetting,
    changeAutoPlay,
    setAutoMergeRooms,
    setDisabledEmoticons,
    setDisabledReceivingGifts,
    setDisabledShowGifts,
    changeShowHint,
    changeShowIgnoredRooms,
    changeNotification,

}) => {
  const [activeTab, setActiveTab] = useState('1');
  const [beforeSettings, setBeforeSettings] = useState([]);
  const [devMode, setDevMode] = useState(false);

  const [disabledAutoPlayMode, setDisabledAutoPlayMode] = useState(disabledAutoPlay || false);
  const [autoMergeRoomsState, setAutoMergeRoomsState] = useState(autoMergeRooms || false);
  const [showHintMode, setShowHintMode] = useState(showHint || false);
  const [showIgnoredRoomsMode, setShowIgnoredRoomsMode] = useState(showIgnoredRooms || false);

  const [disabledEmoticonsState, setDisabledEmoticonsState] = useState(disabledEmoticons || false);
  const [disabledReceivingGiftsState, setDisabledReceivingGiftsState] = useState(disabledReceivingGifts || false);
  const [disabledShowGiftsState, setDisabledShowGiftsState] = useState(disabledShowGifts || false);

  const [settingsPopover, setSettingsPopover] = useState(null);

  const [lightThemePopoverOpen, setLightThemePopoverOpen] = useState(null);
  const [normalThemePopoverOpen, setNormalThemePopoverOpen] = useState(null);
  const [darkThemePopoverOpen, setDarkThemePopoverOpen] = useState(null);

  const [darkTheme, setDarkTheme] = useState(screenMode || SCREEN_MODE.normal);

  const { t, i18n } = useTranslation('settings');

  useEffect(() => setDisabledAutoPlayMode(disabledAutoPlay), [disabledAutoPlay]);
  useEffect(() => setAutoMergeRoomsState(autoMergeRooms), [autoMergeRooms]);
  useEffect(() => setDisabledEmoticonsState(disabledEmoticons), [disabledEmoticons]);
  useEffect(() => setDisabledReceivingGiftsState(disabledReceivingGifts), [disabledReceivingGifts]);
  useEffect(() => setDisabledShowGiftsState(disabledShowGifts), [disabledShowGifts]);

  useEffect(() => {
    fetchAutoPlay();
    fetchShowHint();
    fetchShowIgnoredRooms();

    const { hostname } = window.location;
    const isDev = hostname.includes('dev.') || hostname.includes('localhost');
    setDevMode(isDev);

    // const language = i18n.language || 'lv';
    // setCurLang(language);

    let tempSettings = [];

    if (!notificationSettings || Object.keys(notificationSettings).length === 0) {
      setDefault(uid);
    }

    if (notificationSettings) {
      map(notificationSettings, (item, key) => {
        if (item) {
          tempSettings.push(key);
        } else {
          if (key === USER_SYSTEM_SETTINGS.newDesign && newDesign) {
            tempSettings.push(key);
          }
        }
      });
    }

    if (
      !notificationSettings?.leaveRoom &&
      !notificationSettings?.lastRound &&
      !notificationSettings?.quitRound &&
      !notificationSettings?.ignorePlayer &&
      !notificationSettings?.quitAccount &&
      !notificationSettings?.purchaseGift &&
      !notificationSettings?.removeGift
    ) {
      tempSettings.push(USER_SYSTEM_SETTINGS.dontShowAnyNotification);
    }

    if (gameSettings?.doubleClickPlay) {
      tempSettings.push(USER_SYSTEM_SETTINGS.doubleClickPlay);
    }

    setBeforeSettings([...tempSettings]);
  }, []);

  const buyVip = () => {
    changeTab(MENU_NAVIGATION.buyPagePremiumPacks);
    showUserSettingsModal();
  }

  const toggleLanguage = (lang) => {
    i18n.changeLanguage(lang);

    ReactGA.event({
      category: 'Language',
      action: 'Change Language',
    });

    try {
      if (window && window.localStorage && window.localStorage.setItem) { //x
        localStorage.setItem('language', lang); //x
      }
    } catch (err) {
      console.log(err);
    }

    setUserLoginStatisticsDispatch(false, null, lang, null);
  }

  const handleToggleTheme = (theme) => {
    theme === SCREEN_MODE.dark && setDarkTheme(SCREEN_MODE.dark);
    theme === SCREEN_MODE.light && setDarkTheme(SCREEN_MODE.light);
    theme === SCREEN_MODE.normal && setDarkTheme(SCREEN_MODE.normal);
    try {
      localStorage.setItem('screenMode', JSON.stringify(theme));
    } catch (err) {
      console.log(err);
    }
    handleSetThemeDispatch(theme);
  };

  const beforeChangeSetting = (setting) => {
    let tempSettings = beforeSettings;
    if (setting === USER_SYSTEM_SETTINGS.dontShowAnyNotification) {
      // !notificationSettings.leaveRoom && !notificationSettings.lastRound && !notificationSettings.quitRound && !notificationSettings.ignorePlayer
      //     && !notificationSettings.quitAccount && !notificationSettings.purchaseGift && !notificationSettings.removeGift
      if (!tempSettings.includes(USER_SYSTEM_SETTINGS.dontShowAnyNotification)) {
        console.log("beforeSettingsPush", tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification), setting, USER_SYSTEM_SETTINGS.dontShowAnyNotification, beforeSettings);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom), 1);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound), 1);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound), 1);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer), 1);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount), 1);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift), 1);
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift), 1);
        tempSettings.push(USER_SYSTEM_SETTINGS.dontShowAnyNotification);
      } else {
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification) !== -1 && beforeSettings.includes(USER_SYSTEM_SETTINGS.leaveRoom) && beforeSettings.includes(USER_SYSTEM_SETTINGS.lastRound) && beforeSettings.includes(USER_SYSTEM_SETTINGS.quitRound) && beforeSettings.includes(USER_SYSTEM_SETTINGS.ignorePlayer) && beforeSettings.includes(USER_SYSTEM_SETTINGS.quitAccount) && beforeSettings.includes(USER_SYSTEM_SETTINGS.purchaseGift) && beforeSettings.includes(USER_SYSTEM_SETTINGS.removeGift)) {
          console.log("beforeSettingsPop", tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification), setting, USER_SYSTEM_SETTINGS.dontShowAnyNotification, beforeSettings);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift) !== -1) tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift), 1);
          tempSettings.push(USER_SYSTEM_SETTINGS.dontShowAnyNotification);
        } else {
          tempSettings.splice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification), 1);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.leaveRoom);;
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.lastRound);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.quitRound);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.ignorePlayer);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.quitAccount);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.purchaseGift);
          if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift) === -1) tempSettings.push(USER_SYSTEM_SETTINGS.removeGift);
        }
      }
    } else {
      if (tempSettings.indexOf(setting) === -1) {
        tempSettings.push(setting);
      } else {
        tempSettings.splice(tempSettings.indexOf(setting), 1);
      }
      if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom) !== -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound) !== -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound) !== -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer) !== -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift) !== -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift) !== -1) {
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification) !== -1) {
          tempSettings.slice(tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification), 1);
        }
      }
      if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift) === -1 && tempSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift) === -1) {
        if (tempSettings.indexOf(USER_SYSTEM_SETTINGS.dontShowAnyNotification) === -1) {
          tempSettings.push(USER_SYSTEM_SETTINGS.dontShowAnyNotification);
        }
      }
    }

        setBeforeSettings([...tempSettings]);
    }

    const changeSettingWrapper = () => {
      map(USER_SYSTEM_SETTINGS, (item) => {
        if (item === USER_SYSTEM_SETTINGS.doubleClickPlay) {
          if ((!gameSettings?.doubleClickPlay && beforeSettings.indexOf(item) !== -1) || (gameSettings?.doubleClickPlay && beforeSettings.indexOf(item) === -1))
            changeSetting(item, uid);
        } else if (item === USER_SYSTEM_SETTINGS.autoPlay) {
          if (disabledAutoPlayMode !== disabledAutoPlay)
            changeAutoPlay(disabledAutoPlayMode);
        } else if (item === USER_SYSTEM_SETTINGS.autoMergeRooms) {
          if (autoMergeRoomsState !== autoMergeRooms)
            setAutoMergeRooms(autoMergeRoomsState);
        } else if (item === USER_SYSTEM_SETTINGS.disabledEmoticons) {
          if (disabledEmoticonsState !== disabledEmoticons)
            setDisabledEmoticons(disabledEmoticonsState);
        } else if (item === USER_SYSTEM_SETTINGS.disabledReceivingGifts) {
          if (disabledReceivingGiftsState !== disabledReceivingGifts)
            setDisabledReceivingGifts(disabledReceivingGiftsState);
        } else if (item === USER_SYSTEM_SETTINGS.disabledShowGifts) {
          if (disabledShowGiftsState !== disabledShowGifts)
            setDisabledShowGifts(disabledShowGiftsState);
        } else if (item === USER_SYSTEM_SETTINGS.showHint) {
          if (showHintMode !== showHint)
            changeShowHint(showHintMode);
        } else if (item === USER_SYSTEM_SETTINGS.showIgnoredRooms) {
          if (showIgnoredRoomsMode !== showIgnoredRooms)
            changeShowIgnoredRooms(showIgnoredRoomsMode);
        } else {
          if ((!notificationSettings[item] && beforeSettings.indexOf(item) !== -1) || (notificationSettings[item] && beforeSettings.indexOf(item) === -1))
            changeNotification(item, uid);
        }
      });

      showUserSettingsModal();
    }

    const cardClickBtnSetting = (beforeSettings.indexOf(USER_SYSTEM_SETTINGS.doubleClickPlay) !== -1);

  const options = SCREEN_MODE_OPTIONS;
  const selectedOption = darkTheme;

  const themePopoverSetters = { light: setLightThemePopoverOpen, normal: setNormalThemePopoverOpen, dark: setDarkThemePopoverOpen };
  const themePopoverVariables = { light: lightThemePopoverOpen, normal: normalThemePopoverOpen, dark: darkThemePopoverOpen };

    return (
        <div className="user-settings-new">
            <div className="user-settings-new-header">
                <SwitchSelect
                    options={[
                        { name: t('generalSettings'), value: '1' },
                        { name: t('confirmationWindows'), value: '2' },
                    ]}
                    selectedOption={activeTab}
                    selectFunc={setActiveTab}
                />
            </div>

      <div className="user-settings-new-body">
        {activeTab === '1' ? (
          <Fragment>
            <div className="user-settings-new-body-section">
              <div className="subsection-title">{t('showResultWindow')}</div>
              <div className="toggle-wrapper">
                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.showAfterRound) !== -1} onChange={() => beforeChangeSetting('showAfterRound')} text={t('showAfterRound')} inlineLabelClassName="switch-text-inline" />
              </div>
              <div className="toggle-wrapper">
                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.showAtRoomEnd) !== -1} onChange={() => beforeChangeSetting('showAtRoomEnd')} text={t('showAtRoomEnd')} inlineLabelClassName="switch-text-inline" />

              </div>

              <div className="subsection-title">{t('others')}</div>

              <div className="toggle-wrapper">
                <Toggle checked={!disabledAutoPlayMode} name="autoPlay" onChange={() => setDisabledAutoPlayMode(!disabledAutoPlayMode)} text={t('autoPlay')} inlineLabelClassName="switch-text-inline" />
              </div>
              <div className="toggle-wrapper">
                <Toggle checked={autoMergeRoomsState} name="autoMergeRoomsState" onChange={() => setAutoMergeRoomsState(!autoMergeRoomsState)} text={t('autoMergeRooms')} inlineLabelClassName="switch-text-inline" />
              </div>
              <div className="toggle-wrapper">
                <Toggle checked={!showHintMode} name="showHint" onChange={() => setShowHintMode(!showHintMode)} text={t('showHint')} inlineLabelClassName="switch-text-inline" />
              </div>
              <div className="toggle-wrapper">
                <Toggle checked={showIgnoredRoomsMode} name="showIgnoredRooms" onChange={() => setShowIgnoredRoomsMode(!showIgnoredRoomsMode)} text={t('showIgnoredRooms')} inlineLabelClassName="switch-text-inline" />
              </div>

            </div>

            <div className="user-settings-new-body-section">
              {devMode ? (
                <>
                  <div className="subsection-title">{t('vip')}</div>

                  <div className="toggle-wrapper" id="disabled-emoticons-toggle" onMouseEnter={() => setSettingsPopover("disabled-emoticons-toggle")} onMouseLeave={() => setSettingsPopover()} style={(!vipUntil || vipUntil < (Date.now() + offset)) ? { opacity: 0.5 } : {}}>
                    <Toggle
                      disabled={(!vipUntil || vipUntil < (Date.now() + offset))}
                      checked={!disabledEmoticonsState || (!vipUntil || vipUntil < (Date.now() + offset))}
                      name="disabledEmoticons"
                      onChange={() => setDisabledEmoticonsState(!disabledEmoticonsState)}
                      text={t('disableEmoticons')}
                      inlineLabelClassName="switch-text-inline"
                    />
                    <IconPopover
                      placement="right"
                      popoverOpen={(!vipUntil || vipUntil < (Date.now() + offset)) && settingsPopover === "disabled-emoticons-toggle"}
                      targetId="disabled-emoticons-toggle"
                    >
                      <div className="game-type-text text-align-center">
                        {t('vipSettingPopover')}
                        <Button color="link" className="layout-highlighted-button" onClick={buyVip}>
                          {t('common:bonusPage.buyVIP')}
                        </Button>
                      </div>
                    </IconPopover>
                  </div>
                  <div className="toggle-wrapper" id="disabled-receive-gifts-toggle" onMouseEnter={() => setSettingsPopover("disabled-receive-gifts-toggle")} onMouseLeave={() => setSettingsPopover()} style={(!vipUntil || vipUntil < (Date.now() + offset)) ? { opacity: 0.5 } : {}}>
                    <Toggle
                      disabled={(!vipUntil || vipUntil < (Date.now() + offset))}
                      checked={!disabledReceivingGiftsState || (!vipUntil || vipUntil < (Date.now() + offset))}
                      name="disabledReceivingGifts"
                      onChange={() => setDisabledReceivingGiftsState(!disabledReceivingGiftsState)}
                      text={t('disabledReceiveGifts')}
                      inlineLabelClassName="switch-text-inline"
                    />
                    <IconPopover
                      placement="right"
                      popoverOpen={(!vipUntil || vipUntil < (Date.now() + offset)) && settingsPopover === "disabled-receive-gifts-toggle"}
                      targetId="disabled-receive-gifts-toggle"
                    >
                      <div className="game-type-text text-align-center">
                        {t('vipSettingPopover')}
                        <Button color="link" className="layout-highlighted-button" onClick={buyVip}>
                          {t('common:bonusPage.buyVIP')}
                        </Button>
                      </div>
                    </IconPopover>
                  </div>
                  <div className="toggle-wrapper" id="disabled-show-gifts-toggle" onMouseEnter={() => setSettingsPopover("disabled-show-gifts-toggle")} onMouseLeave={() => setSettingsPopover()} style={(!vipUntil || vipUntil < (Date.now() + offset)) ? { opacity: 0.5 } : {}}>
                    <Toggle
                      disabled={(!vipUntil || vipUntil < (Date.now() + offset))}
                      checked={!disabledShowGiftsState || (!vipUntil || vipUntil < (Date.now() + offset))}
                      name="disabledShowGifts"
                      onChange={() => setDisabledShowGiftsState(!disabledShowGiftsState)}
                      text={t('disabledShowGifts')}
                      inlineLabelClassName="switch-text-inline"
                    />
                    <IconPopover
                      placement="right"
                      popoverOpen={(!vipUntil || vipUntil < (Date.now() + offset)) && settingsPopover === "disabled-show-gifts-toggle"}
                      targetId="disabled-show-gifts-toggle"
                    >
                      <div className="game-type-text text-align-center">
                        {t('vipSettingPopover')}
                        <Button color="link" className="layout-highlighted-button" onClick={buyVip}>
                          {t('common:bonusPage.buyVIP')}
                        </Button>
                      </div>
                    </IconPopover>
                  </div>
                </>
              ) : (null)}

              <div className="subsection-title">{t('cardPlay')}</div>
              <div className="toggle-wrapper toggle-wrapper-card-play">
                <div className={`switch-text ${cardClickBtnSetting ? 'disable' : 'active'}`}>{t('cardPlaySingle')}</div>
                <Toggle showAsEnabled checked={cardClickBtnSetting} onChange={() => beforeChangeSetting('doubleClickPlay', { type: gameSettings.doubleClickPlay ? 'single' : 'double' })} />
                <div className={`switch-text ${cardClickBtnSetting ? 'active' : 'disable'}`}>
                  <div>{t('cardPlayDouble')}</div>
                  <div className="switch-text-small">{t('cardPlayDoubleSecond')}</div>
                </div>
              </div>


                        </div>  

                        <div className="user-settings-new-body-section-bottom">

                          <div className="subsection-wrapper">
                            <div className="subsection-title">{t('language')}</div>
                            <div className="toggle-wrapper">
                                <Media onClick={() => toggleLanguage('lv')} src={lvFlag} className="language-image" style={{opacity: i18n.language === 'lv' ? 1 : 0.5}} />
                                <Media onClick={() => toggleLanguage('en')} src={enFlag} className="language-image" style={{opacity: i18n.language === 'en' ? 1 : 0.5}} />
                                <Media onClick={() => toggleLanguage('ru')} src={ruFlag} className="language-image" style={{opacity: i18n.language === 'ru' ? 1 : 0.5}}/>
                            </div>
                          </div>

                          <div className="subsection-wrapper">
                            <div className="subsection-title">{t('theme')}</div>
                            <div className="toggle-wrapper">
                                <div className="switch-select-wrapper">
                                    <div className="switch-select">
                                        {(options && options.length) ? options.map((option, index) => (
                                        <>
                                            <div
                                            onClick={(() => handleToggleTheme(option.value))}
                                            key={index}
                                            className={`switch-select-option switch-select-option-${screenMode} ${index === 0 ? 'switch-select-option-first' : ''} ${(index === options.length - 1) ? 'switch-select-option-last' : ''} ${selectedOption === option.value ? 'switch-select-option-active' : ''}`}
                                            id={`${option.value}-theme-button-popover`}
                                            onMouseEnter={() => themePopoverSetters[option.value](true)}
                                            onMouseLeave={() => themePopoverSetters[option.value](false)}
                                            >

                                            <div className="switch-select-option-img">
                                                {
                                                (option.name === 'dark') ? <Media src={(selectedOption === option.value) ? DarkSelectedThemeIcon : DarkThemeModeIcon} className='dark-image' alt='dark-image' /> : (option.name === 'normal') ? <Media src={(selectedOption === option.value) ? NormalSelectedThemeModeIcon : NormalThemeModeIcon} className='normal-image' alt='normal-image' /> : <Media src={(selectedOption === option.value) ? LightSelectedThemeModeIcon : LightThemeModeIcon} className='light-image' alt='light-image' />
                                                }
                                            </div>
                                            </div>
                                            <IconPopover text={t(`common:popovers.${option.value}ThemeSetting`)} placement="bottom" targetId={`${option.value}-theme-button-popover`} popoverOpen={themePopoverVariables[option.value]}/>
                                        </>
                                        )) : (null)}
                                    </div>
                                </div>
                            </div>
                          </div>

                          <div className="subsection-wrapper">
                            <div className="subsection-title">{t('sound')}</div>
                            <div className="toggle-wrapper">
                                <SoundButton uid={uid} screenMode={screenMode} t={t}/>
                            </div>
                          </div>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <div className="user-settings-new-body-section">

                            <div className="subsection-title">{t('showConfirmationWindow')}</div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.leaveRoom) !== -1} name="leaveRoom" onChange={() => beforeChangeSetting('leaveRoom')} text={t('leaveRoom')} inlineLabelClassName="switch-text-inline" />
                            </div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.lastRound) !== -1} name="lastRound" onChange={() => beforeChangeSetting('lastRound')} text={t('lastRound')} inlineLabelClassName="switch-text-inline" />
                            </div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.quitRound) !== -1} name="quitRound" onChange={() => beforeChangeSetting('quitRound')} text={t('quitRound')} inlineLabelClassName="switch-text-inline" />
                            </div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.ignorePlayer) !== -1} name="ignorePlayer" onChange={() => beforeChangeSetting('ignorePlayer')} text={t('ignorePlayer')} inlineLabelClassName="switch-text-inline" />
                            </div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.quitAccount) !== -1} name="quitAccount" onChange={() => beforeChangeSetting('quitAccount')} text={t('quitAccount')} inlineLabelClassName="switch-text-inline" />
                            </div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.purchaseGift) !== -1} name="purchaseGift" onChange={() => beforeChangeSetting('purchaseGift')} text={t('purchaseGift')} inlineLabelClassName="switch-text-inline" />
                            </div>
                            <div className="toggle-wrapper">
                                <Toggle checked={beforeSettings.indexOf(USER_SYSTEM_SETTINGS.removeGift) !== -1} name="removeGift" onChange={() => beforeChangeSetting('removeGift')} text={t('removeGift')} inlineLabelClassName="switch-text-inline" />
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>

            <div className="user-settings-new-footer">
                <ModalFooter>
                    <Button color="secondary" onClick={changeSettingWrapper}>
                        {t('common:common.save')}
                    </Button>
                    <Button color="secondary" onClick={showUserSettingsModal}>
                        {t('common:common.close')}
                    </Button>
                </ModalFooter>
            </div>

    </div>
  );
};

const mapStateToProps = state => ({
  notificationSettings: state.userSettings[state.member.uid] ? (state.userSettings[state.member.uid].notificationSettings) : (state.userSettings.default ? state.userSettings.default.notificationSettings : {}),
  gameSettings: state.userSettings[state.member.uid] ? (state.userSettings[state.member.uid].gameSettings) : (state.userSettings.default ? state.userSettings.default.gameSettings : {}),
  soundOn: state.userSettings.soundOn,
  uid: state.member.uid,
  disabledAutoPlay: state.member.disabledAutoPlay || false,
  newDesign: state.member?.newDesign || false,
  showHint: state.member?.showHint || false,
  showIgnoredRooms: state.member?.showIgnoredRooms || false,
  autoMergeRooms: state.member.autoMergeRooms || null,
  disabledEmoticons: state.member.disabledEmoticons || null,
  disabledReceivingGifts: state.member.disabledReceivingGifts || null,
  disabledShowGifts: state.member.disabledShowGifts || null,
  vipUntil: state.member.vipUntil || null,
  offset: state.member.offset || null,
});

const mapDispatchToProps = (dispatch) => {
  return {
    changeNotification: (setting, userId) => {
      dispatch(changeNotificationSettings(setting, userId));
    },
    changeSetting: (setting, userId) => {
      dispatch(changeGameSetting(setting, userId));
    },
    toggleAllNotifications: (newValue) => {
      dispatch(toggleAllNotificationSettings(newValue));
    },
    setDefault: () => {
      dispatch(setDefaultSettings());
    },
    fetchAutoPlay: () => {
      dispatch(getUserAutoPlay());
    },
    changeAutoPlay: (newValue) => {
      dispatch(toggleAutoPlay(newValue));
    },
    changeShowHint: (newValue) => {
      dispatch(toggleShowHint(newValue));
    },
    fetchShowHint: () => {
      dispatch(getUserShowHint());
    },
    changeShowIgnoredRooms: (newValue) => {
      dispatch(toggleShowIgnoredRooms(newValue));
    },
    fetchShowIgnoredRooms: () => {
      dispatch(getUserShowIgnoredRooms());
    },
    setUserLoginStatisticsDispatch: (param1, param2, param3, param4) => {
      dispatch(setUserLoginStatistics(param1, param2, param3, param4, null, null));
    },
    handleSetThemeDispatch: (theme) => {
      dispatch(handleSetTheme(theme));
    },
    setAutoMergeRooms: (value) => {
      dispatch(updateAutoMergeRooms(value));
    },
    setDisabledEmoticons: (value) => {
      dispatch(updateDisabledEmoticons(value));
    },
    setDisabledReceivingGifts: (value) => {
      dispatch(updateDisabledReceivingGifts(value));
    },
    setDisabledShowGifts: (value) => {
      dispatch(updateDisabledShowGifts(value));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsNew);
